import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useReveal from "@/hooks/useReveal";

export default function AboutClosingCTA() {
  const r = useReveal();
  return (
    <section ref={r} className="relative py-32 md:py-44">
      <div className="max-w-[1180px] mx-auto px-6 md:px-12 text-center">
        <div className="eyebrow mb-8">Be in touch</div>
        <h2 className="font-serif text-5xl md:text-6xl leading-[0.95] tracking-tight font-light">
          We are at our best <br />
          <em className="italic text-indigo_deep">in conversation.</em>
        </h2>
        <Link
          to="/contact"
          className="mt-12 inline-flex items-center gap-3 bg-ink text-ivory px-10 py-5 text-[11px] tracking-widest2 uppercase font-semibold hover:bg-indigo_deep transition-colors"
        >
          Plan a Journey
          <ArrowUpRight size={16} />
        </Link>
      </div>
    </section>
  );
}
